/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for the SearchHistory model.
 * @export
 * @interface SearchHistory
 */
export interface SearchHistory {
    /**
     * 
     * @type {number}
     * @memberof SearchHistory
     */
    readonly id: number;
    /**
     * The search query that was performed
     * @type {string}
     * @memberof SearchHistory
     */
    searchQuery: string;
    /**
     * 
     * @type {Date}
     * @memberof SearchHistory
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SearchHistory
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the SearchHistory interface.
 */
export function instanceOfSearchHistory(value: object): value is SearchHistory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('searchQuery' in value) || value['searchQuery'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SearchHistoryFromJSON(json: any): SearchHistory {
    return SearchHistoryFromJSONTyped(json, false);
}

export function SearchHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'searchQuery': json['search_query'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function SearchHistoryToJSON(json: any): SearchHistory {
      return SearchHistoryToJSONTyped(json, false);
  }

  export function SearchHistoryToJSONTyped(value?: Omit<SearchHistory, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_query': value['searchQuery'],
    };
}

